import styles from './Slider.module.css';

type SliderProps = {
    id: string;
    name: string;
    minValueLabel: React.ReactNode;
    maxValueLabel: React.ReactNode;
    sliderMax: number;
    sliderMin: number;
    value: number;
    handleChange: (value: string) => void;
    onAfterChange: () => void;
    step: number;
    onTouchEnd?: () => void;
};

export const Slider = ({
    id,
    name,
    minValueLabel,
    maxValueLabel,
    sliderMax,
    sliderMin,
    value,
    handleChange,
    onAfterChange,
    step
}: SliderProps) => {
    return (
        <div className="my-l flex w-full flex-row align-middle">
            <label className="mr-s" htmlFor={id}>
                {minValueLabel}
            </label>
            <div className="flex w-full flex-row">
                <span
                    data-testid="minimum-stop"
                    className={styles.minStop}
                ></span>
                <input
                    type="range"
                    className={styles.slider_style}
                    id={id}
                    name={name}
                    step={step}
                    value={value}
                    onChange={(event) => {
                        handleChange(event.target.value);
                    }}
                    onKeyUp={() => onAfterChange()}
                    onMouseUp={() => onAfterChange()}
                    onBlur={() => onAfterChange()}
                    onTouchEnd={() => onAfterChange()}
                    min={sliderMin}
                    max={sliderMax}
                />
                <span
                    data-testid="maximum-stop"
                    className={styles.maxStop}
                ></span>
            </div>

            <label className="ml-s" htmlFor={id}>
                {maxValueLabel}
            </label>
        </div>
    );
};
